export const iconList = {
  IconAddToList: 'add_to_list',
  IconAdministrativeManagement: 'administrative_management',
  IconAnswer: 'answer',
  IconArrow: 'arrow',
  IconAssetplanLogo: 'assetplan_logo',
  IconAvatar: 'avatar',
  IconBackwardsButton: 'backwards',
  IconBankTransfer: 'bank_transfer_16',
  IconBarcode: 'barcode',
  IconBathroom: 'bathroom',
  IconBed: 'bed',
  IconBillingTicket: 'billing_ticket',
  BlackFriday: 'black_friday_icon',
  IconBookmark: 'bookmark',
  IconBudget: 'budget',
  IconBuilding: 'building',
  IconCalendar: 'calendar',
  IconCalendarCircle: 'calendar_new_icon',
  IconCar: 'car',
  IconCarDelivery: 'car_delivery',
  IconInstallments: 'card',
  IconCard: 'card_stripe',
  IconCart: 'cart',
  IconSupermarket: 'cart_cpg',
  IconVolume: 'cart_dxv',
  IconCategories: 'categories',
  IconCBT: 'cbt',
  IconCBTRounded: 'cbt_rounded',
  IconCBTSummary: 'cbt_summary',
  IconCBTWorld: 'cbt_world',
  IconCheck: 'check',
  IconCheckCircle: 'check_circle',
  IconCheckCircleGreen: 'check_circle_icon',
  IconCheckCircleLightGreen: 'check_circle_icon_light_green',
  IconCheckSimple: 'check_simple',
  IconChevron: 'chevron',
  IconCircleNumber1: 'circle_number_1',
  IconCircleNumber2: 'circle_number_2',
  IconCircleNumber3: 'circle_number_3',
  IconClip: 'clip',
  IconClock: 'clock',
  IconClose: 'close',
  IconCockade: 'cockade',
  IconCompass: 'compass',
  ContactFraudModal: 'contacts_fraud_modal',
  IconCopyLink: 'copy',
  IconCoupon: 'coupon',
  IconCouponRedeemed: 'coupon_redeemed',
  IconCreditCard: 'credit_card',
  IconCreditCardUnrounded: 'credit_card_unrounded',
  IconCredits: 'credits',
  IconDebitCard: 'debit_card',
  IconEdit: 'edit',
  ExclamationCircleLightOrange: 'exclamation_circle_light_orange',
  IconExperience: 'experience',
  IconExpress: 'express',
  IconExternalCredits: 'external_credits',
  ExternalCredits: 'external_credits_modal_car',
  IconEyes: 'eye',
  IconFacebook: 'facebook',
  IconFacing: 'facing',
  IconFastTruck: 'fast_truck',
  IconFile: 'file',
  IconFlag: 'flag',
  IconForwardsButton: 'forwards',
  IconFull: 'full_icon',
  IconFullBig: 'full_icon_big',
  IconFullMedium: 'full_icon_medium',
  IconFullSuperLarge: 'full_super_large',
  IconFullSuperLargeMLB: 'full_super_large_mlb',
  IconFullSuperMedium: 'full_super_medium',
  IconFullSuperMediumMLB: 'full_super_medium_mlb',
  IconFullSuperSmall: 'full_super_small',
  IconFullSuperSmallMLB: 'full_super_small_mlb',
  IconFullSuperXSmall: 'full_super_xsmall',
  IconFullSuperXSmallMLB: 'full_super_xsmall_mlb',
  IconGenericCard: 'generic_card',
  IconGreenVehicle: 'green_vehicle',
  IconAvatarPlus: 'guest',
  IconHelp: 'help',
  IconHiddenEyes: 'hidden-eye',
  IconHireOnline: 'hire_online',
  IconHomeTestDrive: 'home_test_drive',
  HotSale: 'hot_sale',
  IconAhora30: 'ic_ahora30',
  IconGift: 'ic_gift',
  IconOnlineVisitRequest: 'icon-online-visit-request',
  IconVehicleChasis: 'icon_chasis',
  IconVehicleDamage: 'icon_danos',
  IconPackage: 'icon_package',
  IconPackageUnrounded: 'icon_package_unrounded',
  IconVehiclePolice: 'icon_police',
  InfoCheck: 'info_check',
  IconInfoCircleOrange: 'info_icon_orange',
  IconInstagram: 'instagram',
  IconCheckGreenInstallations: 'installations_green_check_icon',
  IconInstallations: 'installations_icon',
  IconCheckOrangeInstallations: 'installations_orange_check_icon',
  IconLaptop: 'laptop',
  IconCreditsOverdue: 'loan_summary',
  IconPin: 'location',
  IconLocationAlt: 'location_alt',
  IconLocationFilled: 'location_filled',
  IconLocationRE: 'location_re',
  IconLocation: 'location_rounded',
  IconLocationUnrounded: 'location_unrounded',
  IconLongTermRentalML: 'long_term_rental_modal_ml',
  IconLongTermRentalPI: 'long_term_rental_modal_pi',
  IconLoyaltyModalLevel: 'loyalty_modal_level',
  IconLoyaltyModalPoints: 'loyalty_modal_points',
  IconLoyaltyModalShipping: 'loyalty_modal_shipping',
  IconLoyaltyPlusRounded: 'loyalty_plus_rounded',
  IconLoyaltyPoints: 'loyalty_points',
  IconLoyaltyTrophy: 'loyalty_trophy',
  IconLoyaltyRounded: 'loyalty_trophy_rounded',
  IconEmail: 'mail',
  ExternalCreditsModalCar: 'mc_credits_modal_car',
  IconMCLoan: 'mc_loan',
  IconMechanicWarranty: 'mechanic_warranty',
  IconMedal: 'medal',
  IconMeliCoins: 'meli_coins',
  IconMeliDolar: 'meli_usd',
  IconMeliChoice: 'melichoice_icon',
  IconMeliChoiceLogo: 'melichoice_logo',
  IconPlus: 'meliplus_icon',
  IconLoyaltyPlus: 'meliplus_loyalty_points',
  IconCoinsBuy: 'mercado_coin_buy',
  IconCoinsSell: 'mercado_coin_sells',
  IconMenssage: 'message',
  IconMessageAlert: 'message_alert',
  MinusCircleGrayDisabled: 'minus_circle_gray_disabled',
  IconMoney: 'money',
  MPagoLogo: 'mpago_logo',
  MPagoLogoRounded: 'mpago_rounded',
  MShopsLogo: 'mshops_logo',
  IconOffice: 'office',
  OnboardingCatalogIcon1: 'onboarding-catalog-icon-1',
  OnboardingCatalogIcon2: 'onboarding-catalog-icon-2',
  IconOwnersNumber: 'owners_number',
  IconPadlock: 'padlock',
  IconPauseButton: 'pause',
  IconPaymentClock: 'payment_clock',
  IconPaypal: 'paypal',
  IconPendingFines: 'pending_fines',
  IconPets: 'pets',
  IconPhoneInfo: 'phone_info',
  IconPhotos: 'photos',
  IconPickUp: 'pick_up',
  IconPinRealEstate: 'pin_real_estate',
  IconPlayButton: 'play_button',
  IconPlay: 'play',
  IconPodium: 'podium',
  IconPointsOfInterestCommerce: 'points_of_interest_commerce',
  IconPointsOfInterestEducation: 'points_of_interest_education',
  IconPointsOfInterestHealth: 'points_of_interest_health',
  IconPointsOfInterestLeisure: 'points_of_interest_leisure',
  IconPointsOfInterestTransport: 'points_of_interest_transport',
  IconPointsOfInterestWalking: 'points_of_interest_walking',
  IconPolyFull: 'poly_full',
  IconPolyStarFill: 'poly_star_fill',
  IconPolyStarHalf: 'poly_star_half',
  IconPolyStar: 'poly_star',
  IconPriceInfo: 'price_info',
  IconPriorAuctions: 'prior_auctions',
  IconPrivacyCircle: 'privacy_circle',
  IconPrivacy: 'privacy',
  IconProperty: 'property',
  IconProtectedBuyRounded: 'protected_buy_rounded',
  IconProtectedBuyUnrounded: 'protected_buy_unrounded',
  IconProtectedBuy: 'protected_buy',
  IconQuestionAi: 'question_ai',
  IconRealEstate: 'real-estate',
  IconRecommendationsBufloInfo: 'recommendations-buflo_icon_info',
  IconRecommendationsCbt: 'recommendations-cbt_icon',
  IconRecommendationsChevron: 'recommendations-chevron',
  IconRecommendationsCpg: 'recommendations-cpg_icon',
  IconRecommendationsFull: 'recommendations-full_icon',
  IconRecommendationsMeliCoins: 'recommendations-meli_coins',
  IconRecommendationsMelichoiceLogo: 'recommendations-melichoice_logo',
  IconRecommendationsMShopsLogo: 'recommendations-mshops_logo',
  IconRecommendationsStarEmpty: 'recommendations-star-empty',
  IconRecommendationsStarFull: 'recommendations-star-full',
  IconRecommendationsStarHalf: 'recommendations-star-half',
  IconRemoveTradeIn: 'remove_trade_in',
  IconMessageNegativeV2: 'rep_seller_attention_bad_v2',
  IconMessageNegative: 'rep_seller_attention_bad',
  IconMessageDisabledV2: 'rep_seller_attention_disabled_v2',
  IconMessageDisabled: 'rep_seller_attention_disabled',
  IconMessagePositiveV2: 'rep_seller_attention_good_v2',
  IconMessagePositive: 'rep_seller_attention_good',
  IconMessageRegular: 'rep_seller_attention_regular',
  IconCalendarNegative: 'rep_seller_calendar_bad',
  IconCalendarDisabled: 'rep_seller_calendar_disabled',
  IconCalendarPositive: 'rep_seller_calendar_good',
  IconCalendarRegular: 'rep_seller_calendar_regular',
  IconTimeNegativeV2: 'rep_seller_delivery_time_bad_v2',
  IconTimeNegative: 'rep_seller_delivery_time_bad',
  IconTimeDisabledV2: 'rep_seller_delivery_time_disabled_v2',
  IconTimePositiveV2: 'rep_seller_delivery_time_good_v2',
  IconTimePositive: 'rep_seller_delivery_time_good',
  IconTimeRegular: 'rep_seller_delivery_time_regular',
  IconSellerSellsGood: 'rep_seller_sells_good',
  IconTimeDisabled: 'rep_seller_time_disabled',
  IconResponse: 'response',
  IconReturnsArrow: 'returns_arrow',
  IconReturnsRounded: 'returns_rounded',
  IconReturn: 'returns',
  IconRightArrow: 'right_arrow',
  IconRoundedSearch: 'rounded_search',
  IconFastTruckMediumAlt: 'rounded_truck_medium_alt',
  IconFastTruckMedium: 'rounded_truck_medium',
  IconRoundedTruck: 'rounded_truck',
  IconRuler: 'ruler',
  IconSaleExchange: 'sale_with_exchange',
  IconSanitizationPolicy: 'sanitization_policy',
  IconScaleUp: 'scale_up',
  IconSchedulableTruck: 'schedulable_truck',
  IconSearchTrigger: 'search-trigger',
  IconSearch: 'search',
  IconSellerAgreement: 'seller_agreement',
  IconShare: 'share',
  IconShareGallery: 'sharegallery',
  IconShieldAvatar: 'shield',
  IconSingleOwner: 'single_owner',
  IconSocialWhatsapp: 'social_whatsapp',
  IconSupermarketFS: 'supermarket_fs_icon',
  IconSupermarketText: 'supermarket_icon',
  IconTheftReport: 'theft_reports',
  IconThumbUpMini: 'thumb_up_mini',
  IconThumbUp: 'thumb_up',
  IconTicket: 'ticket',
  IconTimer: 'timer',
  IconTooltipInfo: 'tooltip',
  IconTour360: 'tour360',
  IconTradeIn: 'trade_in',
  IconShipping: 'truck',
  IconTwitter: 'twitter',
  IconUnitFloor: 'unit_floor',
  IconUser: 'user',
  VehicleGoodCondition: 'vehicle_good_condition',
  IconVehicleHistoryModal: 'vehicle_historic_modal',
  IconVerifiedLarge: 'verified_large',
  IconVerifiedNormal: 'verified_small',
  IconVirtualTours: 'virtual_tours',
  IconWarningBadge: 'warning_badge',
  IconWarning: 'warning',
  IconWarrantyCheck: 'warranty_check',
  IconWarranty: 'warranty',
  IconWhatsapp: 'whatsapp',
  IconNegotiablePrice: 'with_negotiable_price',
  IconIpva: 'with_paid_ipva',
  IconWithdrawalRight: 'withdrawal_right',
  IconYoutubeVideo: 'youtube_video',
  IconSmartphone: 'smartphone',
  IconFile2: 'icon_file',
};
